import React, { FC } from 'react';
import { Icon, IconProps } from '../Icon';

export const ArrowUp: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="currentColor"
      d="M15.293 3.293a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1-1.414 1.414L17 6.414V28a1 1 0 1 1-2 0V6.414l-3.293 3.293a1 1 0 0 1-1.414-1.414l5-5Z"
    />
  </Icon>
);
